import React, { useContext } from "react"
import { CoolButton } from "../CoolButton.jsx"
import { GlobalStateContext } from "../providers/GlobalStateProvider.jsx"
import { useTranslation } from "react-i18next"
import KopyLogo from "../../assets/kopy-logo-square.png"

export const KopyBasicUpgradeCards = ({ onUpgradeClick }) => {
	const { state } = useContext(GlobalStateContext)
	const { t } = useTranslation()

	const featuresAdvertised = [
		t("upgrade_basic.copy_individual_products_from"),
		t("upgrade_basic.copy_collections_and_entire_stores_from_shopify"),
	]

	const xIcon = (
		<svg
			style={{ color: "red", minWidth: "1.3rem" }}
			width="1.3rem"
			height="1.3rem"
			viewBox="0 0 15 15"
		>
			<path
				fill="currentColor"
				d="M3.64 2.27L7.5 6.13l3.84-3.84A.92.92 0 0 1 12 2a1 1 0 0 1 1 1a.9.9 0 0 1-.27.66L8.84 7.5l3.89 3.89A.9.9 0 0 1 13 12a1 1 0 0 1-1 1a.92.92 0 0 1-.69-.27L7.5 8.87l-3.85 3.85A.92.92 0 0 1 3 13a1 1 0 0 1-1-1a.9.9 0 0 1 .27-.66L6.16 7.5L2.27 3.61A.9.9 0 0 1 2 3a1 1 0 0 1 1-1c.24.003.47.1.64.27"
			></path>
		</svg>
	)
	const checkmarkIcon = (
		<svg
			style={{ color: "green", minWidth: "1.3rem" }}
			width="1.3rem"
			height="1.3rem"
			viewBox="0 0 512 512"
		>
			<path
				d="M448 71.9c-17.3-13.4-41.5-9.3-54.1 9.1L214 344.2l-99.1-107.3c-14.6-16.6-39.1-17.4-54.7-1.8-15.6 15.5-16.4 41.6-1.7 58.1 0 0 120.4 133.6 137.7 147 17.3 13.4 41.5 9.3 54.1-9.1l206.3-301.7c12.6-18.5 8.7-44.2-8.6-57.5z"
				fill="currentColor"
			></path>
		</svg>
	)

	return (
		<div style={{ display: "flex", justifyContent: "center" }}>
			<div
				style={{
					display: "flex",
					gap: "1rem",
					justifyContent: "center",
					alignItems: "start",
					flexWrap: "wrap",
				}}
			>
				<div
					className="border shadow"
					style={{
						background: "#fff",
						color: "#333",
						borderRadius: "1.5rem",
						padding: "1rem 1.5rem",
						width: "25rem",
					}}
				>
					<p
						style={{
							fontSize: "2rem",
							fontWeight: "800",
							marginBottom: "1rem",
						}}
					>
						{t("protect.upgrade.current_plan")}
					</p>
					<div style={{ marginBottom: "2rem" }}>
						<div
							style={{
								display: "flex",
								gap: "0.5rem",
								alignItems: "start",
								marginBottom: "1rem",
							}}
						>
							{xIcon}
							<div style={{ fontSize: "0.9rem" }}>
								{t(
									"protect.upgrade.copy_any_competitors_products_and_collections_on_shopify_amazon_aliexpress_etsy_and_cjdropshipping",
								)}
							</div>
						</div>
					</div>
				</div>

				<div
					className="border shadow"
					style={{
						background: "#333",
						color: "#fff",
						borderRadius: "1.5rem",
						padding: "1rem 1.5rem",
						width: "25rem",
					}}
				>
					<div
						style={{
							display: "flex",
							gap: "0.5rem",
							alignItems: "center",
							marginBottom: "1rem",
						}}
					>
						<img
							src={KopyLogo}
							style={{
								height: "2.5rem",
								width: "2.5rem",
								borderRadius: "0.5rem",
							}}
						/>
						<p style={{ fontSize: "2rem", fontWeight: "800" }}>
							Kopy Basic
						</p>
					</div>
					<div style={{ marginBottom: "2rem" }}>
						{featuresAdvertised.map((feature, index) => {
							return (
								<div
									key={index}
									style={{
										display: "flex",
										gap: "0.5rem",
										alignItems: "start",
										marginBottom: "0.5rem",
									}}
								>
									{checkmarkIcon}
									<div style={{ fontSize: "0.9rem" }}>
										{feature}
									</div>
								</div>
							)
						})}
					</div>

					<CoolButton onClick={onUpgradeClick}>
						<span style={{ color: "#222", fontWeight: "700" }}>
							{state.hasTrialedKopyBasicBefore
								? t("protect.upgrade.upgrade_now")
								: t("protect.upgrade.start_3_day_free_trial")}
						</span>
					</CoolButton>
				</div>
			</div>
		</div>
	)
}
